module.exports = __webpack_public_path__ + "static/media/thin-arrow-right.c6d93cbe.svg";